export default "__VITE_ASSET__D0rcLuun__"